import React, { useEffect, useState } from "react";
import { useForm, ValidationError } from '@formspree/react';

import send from "../../img/send.svg";

const Contact = () => {
  const [state, handleSubmit] = useForm("mzzvakpv"); 
  const [popupVisible, setPopupVisible] = useState(false);

  useEffect(() => {
    if (state.succeeded || state.errors) {
      setPopupVisible(true);
      const timeoutId = setTimeout(() => {
        setPopupVisible(false);
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
  }, [state.succeeded, state.errors]);

  return (
    <main className="contact" data-testid='contact-component'>
      <div className="title-container">
        <h1 id="contact" className="title">Contact</h1>
        <div className="title-separator"></div>
      </div>
      <p className="description">Envie de discuter d'un projet où vous avez simplement une question ? Voici comment me contacter !</p>
      <div className="contact-container">
        {popupVisible && state.succeeded && <p className="popup">Votre message à bien été envoyé ! &ensp;&#10003;</p>}
        {popupVisible && state.errors && <p className="popup error">Erreur lors de l'envoi du message. &ensp;&#10008;</p>}
        <form onSubmit={handleSubmit}>
          <div className="contact-fields">
            <input name="name" type="text" placeholder="Nom*" required/>
            <ValidationError prefix="name"  field="name" errors={state.errors} />
            <input name="email" type="email" placeholder="Email*" required/>
            <input name="number" type="tel" placeholder="Téléphone"/>
            <ValidationError prefix="email"  field="email" errors={state.errors} />
            <textarea name="message" id="message" placeholder="Votre message*" required></textarea>
            <ValidationError prefix="message"  field="message" errors={state.errors} />
            <button type="submit" disabled={state.submitting} className="classic-button">Envoyer <img src={send} alt="envoyer message" /></button>
          </div>
        </form>
      </div>
    </main>
  );
}
 
export default Contact;